export const HOME = '/';
export const PRIVACY_POLICY = '/privacy_policy';
export const CONTACT_US = '/contact_us';
export const TERMS = '/terms';